import { render } from "./ModuleThreeSections.vue?vue&type=template&id=af054ffc"
import script from "./ModuleThreeSections.vue?vue&type=script&lang=js"
export * from "./ModuleThreeSections.vue?vue&type=script&lang=js"

import "./ModuleThreeSections.vue?vue&type=style&index=0&id=af054ffc&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__